document.addEventListener("DOMContentLoaded", () => {
  const input = document.querySelector(".search-input");
  const wrapper = document.querySelector(".predictive-search-form__content-wrapper");
  const form = document.querySelector(".predictive-search-form");

  if (!input || !wrapper || !form) {
    console.log("No encontré alguno de los elementos");
    return;
  }

  // Mostrar / ocultar mientras escribe
  input.addEventListener("input", () => {
    if (input.value.trim().length > 0) {
      wrapper.classList.add("active");
    } else {
      wrapper.classList.remove("active");
    }
  });

  // Cerrar si se hace clic fuera
  document.addEventListener("click", (event) => {
    if (!form.contains(event.target)) {
      wrapper.classList.remove("active");
    }
  });
});
